import axios from "@/helpers/axios";

const base_url = process.env.VUE_APP_API_BASEURL;

async function list(params) {
  return axios.get(`${base_url}batteries`, { params }).then((response) => {
    return response.data;
  });
}
async function show(params) {
  return axios.get(`${base_url}batteries/${params.id}`, { params }).then((response) => {
    return response.data;
  });
}

async function add(battery) {
  return axios.post(`${base_url}batteries`, battery).then((response) => {
    return response.data;
  });
}

async function update(battery) {
  return axios.put(`${base_url}batteries/${battery.id}`, battery).then((response) => {
    return response.data.body;
  });
}

async function destroy(battery) {
  return axios.delete_method(`${base_url}batteries/${battery.id}`, battery).then((response) => {
    return response.data.body;
  });
}

export default {
  list,
  show,
  add,
  update,
  destroy
};
